import { VITE_MOCK_API, VITE_REFERENCE_DATA_DATA_API, VITE_USE_MOCK } from 'Constants/appEnvConstants'

export default function getAppSearchUrl() {
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_REFERENCE_DATA_DATA_API; // eslint-disable-line no-undef
}
